import React from 'react';
import { fromPairs, map, isEqual } from 'lodash';
import { button as Button } from 'modules/button';
import { Form } from 'modules/form';
import classnames from 'classnames';


// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { viewCase as ViewCase } from 'ui/views/widgets/viewCase';
 *
 * // render
 * <ViewCase propName='propValue'/>
 */
export const viewCase = ( props ) => {

    // field
    const title = props.title ;

    const { actions = [] } = props;

    const subheaders = props.primaryColumns;

    return (
        <div className='ui-view-case'>
			<div className='ui-view-case__header'>

				{/* title for the modal */}
				<div className='ui-view-case__header__title'>
					{ getLabel( title ) }
				</div>

				{/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

			</div>

            <div className='ui-view-case__subheader' >
                
                { map( subheaders, ( subheader, index ) => {

                    return (
                        <div key={ index } className='ui-view-case__subheader__item'>
                            <div className='ui-view-case__subheader__item__title'>
                                { getLabel( subheader.title.refId ) }
                            </div>
                            <div className='ui-view-case__subheader__item__value'>
                                { props.data.state[ subheader.name ] }
                            </div>
                        </div>
                    );
                } ) }
            </div>

            <div className='ui-view-case__divider'></div>

            <div className='ui-view-case__body'>

                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    key={ props.formId }
                >
                    { ( { fields, isValid, errors, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-view-case__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {
                                    
                                    const className = classnames(
                                        'ui-view-case__body__form__field',
                                        `ui-view-case__body__form__field--${ field.name }`
                                    );

                                    return (
                                        <field.view
                                            className={ className }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            config={ field.config }
                                            
                                            placeholder={ props.data.state.values[ field.name ] }
                                            label={ field.title }
                                            value={ props.data.state.values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-view-case__body__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                { ...action }
                                                key={ action.name }
                                                id= { action.name }

                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                disabled={ 'cancel' !== action.name ? !isValid : false }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-view-case__body__actions__action'
                                                onClick = { isEqual( 'close', action.name ) ? () => {
                                                    props.closeOverlay();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>

                            </form>
                        );
                    } }
                </Form>
            </div>
           
        </div>
    );
};

// set display name
viewCase.displayName = 'viewCase';

// set default props
viewCase.defaultProps = {};

// prop types
viewCase.propTypes = {};
